export class DeepCopy {
    static deepcopy(obj: any) {
        return JSON.parse(JSON.stringify(obj));
    }
}
